// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Translations from './pages/Translations';
import Contact from './pages/Contact';


const App = () => {
  return (
    <div>
      <Header />
  
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/translations" element={<Translations />} />
        <Route path="/contact" element={<Contact />} />
      
      </Routes>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default App;